<template>
    <div>
      <div class="fu">
        <h1 class="title">BMS电池录入教程（初次使用）</h1>
        <p class="test">
            BMS电池录入教程如下。  
        </p>

        <iframe class="antenae" src="//player.bilibili.com/player.html?aid=393668449&bvid=BV1Ld4y1p7gC&cid=988285282&page=1"
         scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
       </div>
    </div>
  </template>
  
  <script>
    export default {
            name:"BmsEnter"
    }
  </script>
  
  <style scoped>
  @media(max-width:768px) {
    .test{
    font-size: 5vw;
    border-left: 5px solid #42b983;
    background-color: #f3f5f7;
    padding-left:1vw;
    font-family: Helvetica Neue, SimSun, 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  }
    .title{
    font-size: 6vw;
    color: #2c3e50;
  }
    .antenae{
    width: 90vw;
    height: 45vh;
    }
    .fu{
      width:100%;
      margin-left: 0px;
    }
  }
  
  @media (min-width: 768px){
    .test{
    font-size: 20px;
    border-left: 5px solid #42b983;
    background-color: #f3f5f7;
    padding-left:1vw;
    font-family: Helvetica Neue, SimSun, 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  }
  .title{
    font-size: 30px;
    color: #2c3e50;
  }
  .fu{
  margin-left: 13vw;
  margin-right: 7vw;
  }
  .antenae{
    width: 50vw;
    height: 60vh;
  }
  }
  </style>